import React, { useState, useEffect } from 'react';
import { Button, Modal, Spin } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import cancelImg from '../../public/img/newMain/cancel.png';
import './assignmentModal.css'
import FileViewer from 'react-file-viewer';

const AssignmentModal = (props) => {

    const [isLoad, setIsLoad] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [fileType, setFileType] = useState('');
    const [filePath, setFilePath] = useState('');
    const [base64Images, setBase64Images] = useState([]);

    useEffect(() => {
        loadFile(props.studentModuleAssignModel?.filePath);
    }, []);

    const loadFile = (fileName) => {
        let fileType = fileName.split('.').pop();
        let filePath = `${Config.assign}${fileName}?${Config.sasToken}`;
        setFileType(fileType);
        if (fileType == "pptx" || fileType === "ppt") {
            convertPptToBase64(filePath);
        } else {
            setFilePath(filePath);
        }
    };

    const convertPptToBase64 = (filePath) => {
        setIsLoad(true);
        fetch(Config.apiServer + "file/convertPptToBase64", {
            method: 'POST',
            body: JSON.stringify(filePath),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            setBase64Images(data);
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        props.onClose(false);
    }

    const downloadFile = () => {
        if (!Base.stopClick()){
            return;
        }
        Base.downloadFile(Config.assign + props.studentModuleAssignModel?.filePath + '?' + Config.sasToken, props.studentModuleAssignModel?.fileName)
    }

    const onError = (e) => {
        console.log(e, 'error in file-viewer');
    }

    const errorComponent = () => {
        return <div>
            File loading failed, please try again later!
        </div>
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            footer={false}
            className='assignmentModal'
        >
            <Spin size="large" spinning={isLoad} >
                <div className='contentBox'>
                    <div className={'fileViewerBox ' +  ((fileType == "pptx" || fileType === "ppt") ? "pptViewerBox" : "")}>
                        {(fileType == "pptx" || fileType === "ppt") ?
                            base64Images?.map((item, index) => 
                                <img key={index} src={item} />
                            )
                        :
                            <FileViewer
                                fileType={fileType}
                                filePath={filePath}
                                errorComponent={errorComponent}
                                onError={onError} />
                        }
                    </div>
                    <div className='buttonBox'>
                        <Button className="websiteSysButton downloadButton" icon={<DownloadOutlined />} onClick={() => downloadFile()}>Download</Button>
                        <div className='websiteSysButton cancelButton' onClick={cancel}><img src={cancelImg} />Cancel</div>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

AssignmentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    studentModuleAssignModel: PropTypes.object.isRequired,
}
export default AssignmentModal;